export const CloseIcon = ({ className = '', fill = '#777777' }) => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="1.85986"
        y="7.48193"
        width="9.66756"
        height="1"
        rx="0.483378"
        transform="rotate(-45 1.85986 7.48193)"
        fill={fill}
      />
      <rect
        x="2.54639"
        y="0.645996"
        width="9.66756"
        height="1"
        rx="0.483378"
        transform="rotate(45 2.54639 0.645996)"
        fill={fill}
      />
    </svg>
  )
}
